import { createSlice } from "@reduxjs/toolkit";
import URL from "../../common/types/url-types";
var initialState = {
    steps: [
        {
            content: [
                "Spearheaded the coordination of CI/CD pipeline implementation utilizing Jenkins and Ansible, slashing deployment cycle times by 22% and fortifying deployment reliability by integrating robust error-checking protocols.",
                "Contributed to application containerization using Kubernetes and Docker, enhancing resource utilization by 15% and driving down server costs through advanced load balancing and auto-scaling techniques.",
                "Developed and optimized a Java REST API with CQRS, integrating AWS services like X-Ray and DynamoDB, achieving a 30% boost in request handling efficiency and 25% increase in data throughput.",
            ],
            header: "May 2024 - Present",
            title: {
                position: "Software Automation Engineer Intern ",
                company: {
                    name: "Ensono",
                    url: URL.ENSONO,
                },
            },
        },
        {
            content: [
                "Utilized React Context API to manage global state across multiple components, reducing unnecessary re-renders by 18% and increasing user engagement by streamlining interactions, resulting in a 12% uptick in session durations.",
                "Integrated Redis caching into a Node.js and MongoDB architecture, effectively reducing API response times by 26% and boosting query speed by 31%, significantly enhancing overall data retrieval efficiency and performance.",
                "Enhanced backend operations in Express.js by employing asynchronous routes with async/await, significantly improving data handling efficiency and decreasing response delays by 20% during peak usage times.",
            ],
            header: "Jan. 2024 - April 2024",
            title: {
                position: "Software Engineer Intern ",
                company: {
                    name: "CommunityConnect",
                    url: URL.COMMUNITYCONNECT,
                },
            },
        },
        {
            content: [
                "Led and managed 50+ members and fostered collaboration for technical skill growth in software development.",
                "Hosted biweekly seminars on front end development with an average attendance of 20 participants per session.",
                "Developed modern and responsive web applications utilizing React and Typescript for 12 student organizations, resulting in a 22% increase in online engagement and club recruitment.",
            ],
            header: "Jan. 2023 - Present",
            title: {
                position: "Coding Club President ",
                company: {
                    name: "Wayne State University",
                    url: URL.WAYNE,
                },
            },
        },
        {
            content: [
                "Led study sessions and held office hours for 110+ students, contributing to a 14% increase in exam scores.",
                "Facilitated review workshops, resulting in a 25% increase in attendance and student participation.",
                "Developed a Python program that processes and formats participation and attendance data from Zoom chat sessions into a PDF file, reducing time spent on manual data collection by 96%.",
            ],
            header: "Aug. 2021 - May. 2022",
            title: {
                position: "STEM Teaching Assistant",
                company: {
                    name: "Wayne State University",
                    url: URL.WAYNE,
                },
            },
        },
        {
            content: [
                "Worked with healthcare professionals to examine the impact of hemophilia on 35 older individuals.",
                "Created presentations and documentation to communicate findings to a non-technical audience.",
                "Wrote Pythons script utilizing the spaCy library for natural language processing to parse through transcripts and perform sentiment analysis, reducing time spent on data processing by 22 hours per week.",
            ],
            header: "Aug. 2021 - May. 2022",
            title: {
                position: "Undergraduate Research Assistant",
                company: {
                    name: "Wayne State University",
                    url: URL.WAYNE,
                },
            },
        },
    ],
};
var componentReducer = createSlice({
    name: "timeline",
    initialState: initialState,
    reducers: {},
});
export default componentReducer.reducer;
